import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import YesOrNoCheckbox from '../../../YesOrNoCheckbox/YesOrNoCheckboxView';

export const validator = hasHomeownerAssociationFee => () => {
  if (hasHomeownerAssociationFee !== true && hasHomeownerAssociationFee !== false) {
    return ['Please select an option'];
  }
  return [];
};

class HasHomeownerAssociationFee extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      workflowId,
      preprocessYesOrNoHasHomeownersAssociationFee,
      hasHomeownerAssociationFee,
      isPopulated,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessYesOrNoHasHomeownersAssociationFee(workflowId, hasHomeownerAssociationFee);
    }
  }

  render() {
    const {
      branch,
      workflowId,
      alreadyHadHomeownerAssociationFee,
      nextIterators,
      yesOrNoHomeownerAssociationFee,
      onChangedYesOrNoHomeownerAssociationFee,
      onPostProcess,
      onPostSave,
    } = this.props;

    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={alreadyHadHomeownerAssociationFee}
      >
        <Validation
          workflowId={workflowId}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasHomeownerAssociationFee`}
        />

        <h2>Is there a homeowners association fee for the property?</h2>
        <YesOrNoCheckbox
          checked={yesOrNoHomeownerAssociationFee}
          onClick={onChangedYesOrNoHomeownerAssociationFee(workflowId)}
        />
        <Navigation
          nextIterators={nextIterators}
          dirtyGraphNodes={[]}
          validator={validator(yesOrNoHomeownerAssociationFee)}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasHomeownerAssociationFee`}
          workflowId={workflowId}
          backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
          doNotSave={yesOrNoHomeownerAssociationFee}
          onPostProcess={onPostProcess(yesOrNoHomeownerAssociationFee)}
          onPostSave={onPostSave(workflowId)}
        />
      </AdvWorkflowStep>
    );
  }
}

HasHomeownerAssociationFee.defaultProps = {
  yesOrNoHomeownerAssociationFee: null,
};

HasHomeownerAssociationFee.propTypes = {
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number.isRequired).isRequired)
    .isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  hasHomeownerAssociationFee: PropTypes.bool.isRequired,
  yesOrNoHomeownerAssociationFee: PropTypes.bool,
  isPopulated: PropTypes.bool.isRequired,
  preprocessYesOrNoHasHomeownersAssociationFee: PropTypes.func.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  alreadyHadHomeownerAssociationFee: PropTypes.bool.isRequired,
  onChangedYesOrNoHomeownerAssociationFee: PropTypes.func.isRequired,
};

export default HasHomeownerAssociationFee;
